import { ShiftSettings } from '../../models'

export const DEFAULT_SHIFT_SETTINGS: ShiftSettings = {
  note: '',
  deadlineOnlineReservationNote: '',
}
